import { render, staticRenderFns } from "./corevalue.vue?vue&type=template&id=296e50dc&scoped=true"
import script from "./corevalue.vue?vue&type=script&lang=js"
export * from "./corevalue.vue?vue&type=script&lang=js"
import style0 from "./corevalue.vue?vue&type=style&index=0&id=296e50dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e50dc",
  null
  
)

export default component.exports